import React, { useEffect, useReducer, useState } from 'react';
import { Button, IconButton, TextField } from '@material-ui/core';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import CancelIcon from '@material-ui/icons/Cancel';
import { withStyles } from '@material-ui/core/styles';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomCheckbox from '../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import EditIcon from '@material-ui/icons/Edit';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { DragIndicator } from '@material-ui/icons';
import { DESITINATION, FEEDBACK_TYPES } from '../../../../constants/FeedbackConst';
import { formDataValidate, VALID_INTEGER } from '../../../../utils/formUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { addFeedback, editFeedback } from '../../../../utils/cmsUtils';
import { useDispatch } from 'react-redux';
import { fetchAllFeedback } from '../../cmsSlice';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const FeedbackCreate = (props) => {
  const { toggleDrawer, feedback, hotelId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isUniqueInfo, setUniqueInfo] = useState(true);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [isInfoUpdate, setIsInfoUpdate] = useState({
    isEdit: false,
    infoIndex: -1,
  });

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    destination: {
      value: '',
      fieldName: 'Destination',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    duration: {
      value: '',
      fieldName: 'Duration after experience (in minutes)',
      errors: {},
      validations: ['required', VALID_INTEGER],
      tab: 0,
    },
    pageTitle: {
      value: '',
      fieldName: 'Feedback Page Title',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    isActive: {
      value: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
    subtext: {
      value: '',
      fieldName: 'Feedback Subtext',
      errors: {},
      validations: [],
      maxLength: 100,
      tab: 0,
    },
    title: {
      value: '',
      fieldName: 'Title 1',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    type: {
      value: '',
      fieldName: 'Feedback type',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    feedback: {
      value: [],
      fieldName: 'feedback',
      errors: {},
      validations: [],
      tab: 1,
    },
  });
  const grid = 8;

  const validate = (tabValue) => {
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  useEffect(() => {
    if (feedback) {
      const currFields = { ...formData };
      currFields.destination.value = feedback.destination;
      currFields.duration.value = feedback.duration;
      currFields.pageTitle.value = feedback.pageTitle;
      currFields.isActive.value = feedback.isActive;
      currFields.subtext.value = feedback.subtext;
      currFields.feedback.value = feedback.feedbackCategories?.map((currInfo, index) => {
        return {
          index: index,
          title: currInfo.title,
          type: currInfo.type,
        };
      });
      setFormData(currFields);
    }
  }, [feedback]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate(0)) {
      try {
        dispatch(stepUpLoaderCount());
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        setLoading(true);
        const feedbackInfo = formData.feedback.value.map((val) => {
          return {
            title: val.title,
            type: val.type,
          };
        });
        const payload = {
          hotelId,
          destination: formData.destination.value,
          duration: formData.duration.value,
          pageTitle: formData.pageTitle.value,
          isActive: formData.isActive.value,
          subtext: formData.subtext.value,
          feedbackCategories: feedbackInfo,
        };
        if (feedback?.id) {
          payload.id = feedback?.id;
          await editFeedback(payload, language);
        } else await addFeedback(payload, language);
        dispatch(fetchAllFeedback(hotelId));
        toggleDrawer('', false, '');
        notificationManager(
          'success',
          `Feedback ${feedback?.id ? 'updated' : 'created'} successfully`,
        );
      } catch (error) {
        notificationManager(
          'danger',
          error?.graphQLErrors
            ? error?.graphQLErrors?.[0]?.message
            : `Error occurred while ${feedback ? 'updating' : 'creating'} feedback `,
        );
        setLoading(false);
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const onInfoAdd = () => {
    if (isInfoUpdate?.isEdit) {
      const currField = { ...formData.feedback };
      const currValue = Array.isArray(formData?.feedback?.value)
        ? [...formData.feedback.value]
        : [];
      const isDuplicate = currValue?.some((info, idx) => {
        if (!info) return false;
        return (
          idx !== isInfoUpdate?.infoIndex &&
          info.title === formData?.title?.value &&
          info.type === formData?.type?.value
        );
      });
      if (isDuplicate) {
        setUniqueInfo(false);
        return;
      } else {
        setUniqueInfo(true);
        if (currValue[isInfoUpdate?.infoIndex]) {
          currValue[isInfoUpdate.infoIndex] = {
            ...currValue[isInfoUpdate.infoIndex],
            title: formData?.title?.value,
            type: formData?.type?.value,
          };
          currField.value = currValue;
          setFormData({ feedback: currField });
        }
        setIsInfoUpdate({ isEdit: false, infoIndex: -1 });
        resetFormData();
      }
    } else {
      if (formData?.title && formData?.type) {
        const currField = { ...formData.feedback };
        const infoArray = Array?.isArray(currField?.value) ? [...currField.value] : [];
        if (
          infoArray?.some((info) => {
            if (!info) return false;
            return info.title === formData?.title?.value && info?.type === formData?.type?.value;
          })
        ) {
          setUniqueInfo(false);
        } else {
          setUniqueInfo(true);
          const currentField = { ...formData.feedback };
          const currList = Array?.isArray(currentField?.value) ? [...currentField.value] : [];
          const newObj = {
            index: currList?.length + 1,
            title: formData?.title?.value,
            type: formData?.type?.value,
          };
          currList?.push(newObj);
          currentField.value = currList;
          setFormData({ feedback: currentField });
          resetFormData();
        }
      }
    }
  };

  const onInfoEdit = (index) => {
    const selectedItem = formData.feedback.value?.find((item, i) => i === index);
    setIsInfoUpdate({ isEdit: true, infoIndex: index });
    let objCopy = { ...formData };
    objCopy.title.value = selectedItem.title;
    objCopy.type.value = selectedItem.type;
    objCopy.index = selectedItem.index;
  };

  const onInfoDelete = (index) => {
    const currField = { ...formData.feedback };
    const infoArray = [...currField.value];
    infoArray.splice(index, 1);
    currField.value = infoArray;
    setFormData({ feedback: currField });
  };

  const resetFormData = () => {
    ['title', 'type'].forEach((item) => {
      let objCopy = { ...formData[item] };
      objCopy.value = '';
      setFormData({ [item]: objCopy });
    });
  };

  const reOrder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: 6,
    margin: `0 0 ${grid}px 0`,
    color: '#828282',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#FBFBFB',
    border: isDragging ? '2px solid #03E67C' : '2px solid #FBFBFB',
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? '#CFF8E0' : '#FFF',
    padding: grid,
    width: '100%',
  });

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reOrder(formData.feedback.value, result.source.index, result.destination.index);

    const currField = { ...formData.feedback };
    currField.value = items;
    setFormData({ feedback: currField });
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === 0),
    );
    delete currTabFromData.title;
    delete currTabFromData.type;
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(isValid);
  }, [formData]);

  return (
    <form className='category-create'>
      <div className='container pt-4 d-flex align-items-end flex-column'>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-11'>
            <span className='page-title'>{feedback ? 'Edit Feedback' : 'Add Feedback'}</span>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <h4 className='tab-title'>Details</h4>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomSelect
                item={formData.destination}
                handleInputChange={(e) => {
                  setFormData({ destination: e });
                }}
                valueField='id'
                labelField='name'
                options={DESITINATION}
                hideNullOption={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.duration}
                handleInputChange={(e) => {
                  setFormData({ duration: e });
                }}
                type='number'
                min={1}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.pageTitle}
                handleInputChange={(e) => {
                  setFormData({ pageTitle: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
            <div className='col-md-3 mb-3'>
              <div className='d-flex align-items-center'>
              <CustomCheckbox
                item={formData.isActive}
                handleInputChange={(e) => {
                  setFormData({ isActive: e });
                }}
                color='primary'
              />
              <CustomToolTip
                title='Deactivating a feedback hides it from Guest app'
                placement='right-end'
              >
                <InfoIcon fontSize='small' style={{ marginLeft: 8}} />
              </CustomToolTip>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <CustomTextField
                item={formData.subtext}
                handleInputChange={(e) => {
                  setFormData({ subtext: e });
                }}
                maxLength='100'
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3 mt-5'>
              <h4 className='tab-title'>Feedback categories</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.title}
                    handleInputChange={(e) => {
                      setUniqueInfo(true);
                      setFormData({ title: e });
                    }}
                    maxLength={50}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.type}
                    handleInputChange={(e) => {
                      setUniqueInfo(true);
                      setFormData({ type: e });
                    }}
                    valueField='id'
                    labelField='name'
                    options={FEEDBACK_TYPES}
                    hideNullOption={true}
                  />
                </div>
              </div>
              {!isUniqueInfo && <div className='input-error'>Duplicate combination</div>}
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <Button
                    variant='outlined'
                    color={formData.title.value && formData.type.value ? 'primary' : 'secondary'}
                    disabled={!formData.title.value || !formData.type.value || false}
                    onClick={() => {
                      onInfoAdd();
                    }}
                  >
                    Add
                  </Button>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3 drag-item'>
                  <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
                    <Droppable droppableId='droppable'>
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={getListStyle(snapshot.isDraggingOver)}
                        >
                          {formData?.feedback?.value.map((item, index) => (
                            <Draggable
                              key={'' + item.index}
                              draggableId={'' + item.index}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style,
                                  )}
                                  className='additional-info-list-item d-flex align-items-center justify-content-between'
                                >
                                  <div className='row w-75'>
                                    <div className='col-md-2'>
                                      <IconButton aria-label='drag' disabled={true}>
                                        <DragIndicator className='additional-info-drag' />
                                      </IconButton>
                                    </div>
                                    <div className='col-md-5 text'>
                                      <TextField
                                        id='additional-info-field-edit'
                                        value={item.title}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div className='col-md-5 text'>
                                      <TextField
                                        id='additional-info-value-edit'
                                        value={item.type}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div>
                                    <IconButton
                                      aria-label='edit'
                                      disabled={isInfoUpdate.isEdit}
                                      onClick={(e) => onInfoEdit(index, 'feedback')}
                                    >
                                      <EditIcon fontSize='small' className='icon' />
                                    </IconButton>
                                    <IconButton
                                      aria-label='delete'
                                      onClick={(e) => onInfoDelete(index)}
                                    >
                                      <RemoveCircleIcon fontSize='small' className='icon' />
                                    </IconButton>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              disabled={!isTabInValid || formData.feedback?.value?.length === 0}
              onClick={handleSubmit}
              variant='contained'
              color='primary'
              className='me-3'
              size='large'
            >
              {feedback ? 'Update' : 'Add'}
            </Button>
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FeedbackCreate;
